import classNames from "classnames"
import { HTMLAttributes, useState } from "react"

export const RadioButton = ({
    isSelected,
    onClick,
    disabled,
    size = "normal",
    ...rest
}: {
    isSelected: boolean
    onClick: () => void
    disabled?: boolean
    size?: "normal" | "small"
} & HTMLAttributes<HTMLDivElement>) => {
    const [isHovering, setIsHovering] = useState(false)
    const [isPressed, setIsPressed] = useState(false)

    return (
        <div
            onClick={disabled ? undefined : onClick}
            onMouseEnter={() => !disabled && setIsHovering(true)}
            onMouseLeave={() => {
                setIsHovering(false)
                setIsPressed(false)
            }}
            onMouseDown={() => !disabled && setIsPressed(true)}
            onMouseUp={() => setIsPressed(false)}
            {...rest}
            className={classNames(
                "relative rounded-full border box-border select-none",
                {
                    "cursor-pointer": !disabled,
                    "border-gray-100": !isSelected && (isPressed || !isHovering) && !disabled,
                    "border-gray-50": isSelected && !isPressed && !isHovering && !disabled,
                    "border-gray-0": isHovering && !isPressed && !disabled,
                    "group-hover:border-gray-0": !isPressed && !disabled,
                    "border-gray-300": isSelected && isPressed && !disabled,
                    "bg-gray-800": !isSelected && !disabled,
                    "bg-gray-700": isSelected && !disabled,
                    "w-6 h-6": size === "normal",
                    "w-4 h-4": size === "small",
                    "border-gray-500 cursor-not-allowed": disabled,
                },
                rest.className
            )}
        >
            {isSelected && (
                <div
                    className={classNames(
                        "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full group-hover:drop-shadow-radio-button",
                        disabled ? "bg-gray-500" : "bg-blue-500",
                        {
                            "drop-shadow-radio-button": isHovering,
                            "w-2.5 h-2.5": size === "normal",
                            "w-[0.4375rem] h-[0.4375rem]": size === "small",
                        }
                    )}
                />
            )}
        </div>
    )
}
